import React from "react";
import FreeSlotsModal from "_c/Modals/free-slots";
import PT from "prop-types";

const MasterFreeSlotsModal = (props) => {
  return (
    <FreeSlotsModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      masterId={props.masterId}
      t={props.t}
    />
  );
};
MasterFreeSlotsModal.propTypes = {
  isOpen: PT.bool.isRequired,
  masterId: PT.string,

  t: PT.func.isRequired,
  onClose: PT.func.isRequired,
};

export default MasterFreeSlotsModal;
